import styled from "styled-components";

export const SelectItem = styled.div`
    height: 40px;
    padding: 5px;
    cursor: pointer;
    padding: 10px 15px;

    &:hover {
        background-color: ${({ theme }) => theme.colors.secondary[100]};
    }
`;
